import {btn, comp, Component, cookies, fieldset, router, tbar, win, Window as GouiWindow} from "@intermesh/goui";
import {t} from "./util/Translate.js";
import {CurrentUser} from "./services/CurrentUser.js";
import {ServerApi} from "./util/ServerApi.js";

export class CheckAuth extends Component {
	private w: GouiWindow | undefined;

	public constructor() {
		super("section");
		this.itemId = "check-auth";
		this.id = "check-auth";
		this.cls = "ifw-card";

		this.items.add(
			comp({cls: "vbox gap ifw-inner-card"},
				comp({
						cls: "ifw-center",
						flex: 1
					},
					comp({cls: "vbox padding ifw-center", width: 200},
						comp({tagName: "i", cls: "icon ifw-big-icon", text: "lock"}),
						comp({text: t("Checking authorization...")})
					)
				)
			)
		);
		this.mask();
		const pc = JSON.parse(localStorage.getItem("portalConfig")!);
		sessionStorage.setItem("preventRedirectToStart", "1"); // prevent automatic redirect to start

		// In certain cases, backend users can move over to the frontend. Therefore, we reset the CurrentUser session
		// variable
		sessionStorage.removeItem(CurrentUser.storageItem);
		CurrentUser.readIf().then(() => {
			const cu = CurrentUser.get();
			if(!cu.id) {
				if (pc!.mayRegister) {
					router.goto('login');
				} else {
					router.goto('welcome');
				}
				return;
			}
			this.w = win({
					title: t("Login detected"),
					modal: true,
					width: 500,
					height: 200,
					closable: false,
					maximizable: false,
					draggable: false,
					resizable: false,
				},
				comp({cls: "vbox", flex: 1},
					fieldset({cls: "pad", flex: 1},
						comp({text: t("You are logged in as '{name}'. Choose your action below:", "core", "core", {name: cu.displayName!})}),
					)
				),
				tbar({},
					btn({
						cls: "primary",
						html: t("Login with my own account"),
						handler: () => {
							const url = ServerApi.url('auth');

							ServerApi.call(url, {}, "DELETE").then((_response) => {
								const lkey = sessionStorage.getItem("language"), // For the Heineken workflow
									lid = sessionStorage.getItem("languageId"); // For the Heineken workflow

								sessionStorage.clear();
								if (lkey && lid) {
									sessionStorage.setItem("language", lkey)
									sessionStorage.setItem("languageId", lid);
								}
								cookies.unset("accessToken", "/");
								// The OOTB supported Non-retarded way
								router.goto("login");
							}).finally(() => {
								this.w!.close();
							});
						}
					}),
					"->",
					btn({
						cls: "primary",
						html: t("Continue with this account"),
						handler: () => {
							CurrentUser.forcePasswordChangePopupCheck("");
							void router.goto("profile");
							this.w!.close();
							// this.continueAfterAuth();
						}
					})
				));
			this.w.show();
		});
	}


	private continueAfterAuth() {
		// TODO? State before auth?
		// if(!$rootScope.stateBeforeAuth) {
		//     console.log("no state before auth?")
		//     $rootScope.stateBeforeAuth = ['selectlanguage', {}, false];
		// }
		const user = CurrentUser.get(), pc = JSON.parse(localStorage.getItem("portalConfig")!);
		if (user.id /*&& pc.mayUseOauth*/) { // TODO: Oauth?
			router.goto('profile');
			this.w!.close();
		} else if (!user.id /* && !$state.is('login') && $rootScope.stateBeforeAuth[2]*/) {
			if (pc.mayRegister) {
				router.goto('login');
			} else {
				router.goto('welcome');
			}
			// } else {
			//     $state.go($rootScope.stateBeforeAuth[0], $rootScope.stateBeforeAuth[1]);
			//     delete $rootScope.stateBeforeAuth;
		}
	}

}